import defer from 'lodash/defer';
import { useEffect } from 'react';

import { useParentHelperContext } from 'pages/ParentHelper/providers/ParentHelperProvider/hooks';
import { useIntersection } from 'shared/hooks/dom';

export const useLoadMore = () => {
  const { loadMore, chatTopicsData, isLoadingChatTopics } =
    useParentHelperContext();

  const { intersection, capturingIntersectionElement } = useIntersection();

  useEffect(() => {
    if (
      intersection?.isIntersecting &&
      chatTopicsData?.nextPageUrl &&
      !isLoadingChatTopics
    ) {
      defer(loadMore);
    }
  }, [
    chatTopicsData?.nextPageUrl,
    intersection?.isIntersecting,
    loadMore,
    isLoadingChatTopics,
  ]);

  return { capturingIntersectionElement };
};
